module.exports = __webpack_public_path__ + "static/media/schedule-concern.01f0f16f.png";